import React from "react";
import { Icon } from "@iconify/react";

const HubIcon = () => (
  <Icon icon="lucide:layers" width={18} height={18} />
);

export default HubIcon;
